import { useEffect, useRef } from "react";
import { useMeals } from "../../contexts/UserMealsContext";
import { useMealTags } from "../../contexts/MealTagContext";

// Bridges MealTagContext and UserMealsContext without either context
// knowing about the other. Meals embed their own tag list (mealTagList),
// which goes stale once a tag is added/deleted elsewhere (e.g. Settings).
// Mounted once at the app root so it reacts immediately, regardless of
// which page the user is currently viewing.
export function MealsTagsSync() {
  const { fetchMeals } = useMeals();
  const { mealTags, loading: mealTagsLoading } = useMealTags();
  const lastSeenMealTags = useRef(null);

  useEffect(() => {
    // Ignore the transient empty -> loaded transition of the tags' own
    // initial fetch; only react once tags have settled.
    if (mealTagsLoading) {
      return;
    }
    if (
      lastSeenMealTags.current !== null &&
      lastSeenMealTags.current !== mealTags
    ) {
      fetchMeals();
    }
    lastSeenMealTags.current = mealTags;
  }, [mealTags, mealTagsLoading, fetchMeals]);

  return null;
}
